'use client';

import Rollbar from 'rollbar';

let rollbarObj: undefined | Rollbar;

export const updateRollbarConfig = (
  codeVersion: string,
  userId: string | null
) => {
  if (rollbarObj) return;
  rollbarObj = new Rollbar({
    accessToken: process.env.NEXT_PUBLIC_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.NEXT_PUBLIC_ENV_NAME,
      person: { id: userId },
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: codeVersion,
        },
      },
    },
  });
};

export const logErrorInfo = async (error: Record<string, unknown>) => {
  const { message } = error;
  console.warn(message);
  rollbarObj?.error(error, { message });
};
